export default __webpack_public_path__ + "static/media/banner7.de832072.jpg";